module.exports = require("@wel-ui/component-vertical-spacing");



//////////////////
// WEBPACK FOOTER
// ../node_modules/@wel-ui/components/VerticalSpacing/index.js
// module id = 158
// module chunks = 0